var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"text-cl-700 text-xs"},[_vm._v("\n\t\t"+_vm._s(_vm.name)+":\n\t")]),_vm._v(" "),_c('p',{staticClass:"text-sm"},[_vm._v("\n\t\t"+_vm._s(_vm.value)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }